// Le panneau de notifications : ouvert par la cloche du rail, sections par
// période (Aujourd'hui, Cette semaine), point rouge sur le non-lu, pied
// avec le compteur et le lien vers les préférences.

import "./notifications.css";

import type { ComptaIconeNom } from "@app/components/compta/ui/ComptaIcone";
import { ComptaIcone } from "@app/components/compta/ui/ComptaIcone";
import type {
  SectionDeNotifications,
  SujetDeNotification,
} from "@app/types/compta/notifications";

// Le sujet d'une notification décide de son icône : c'est le seul endroit
// qui fait le lien.
const ICONE_PAR_SUJET: Record<SujetDeNotification, ComptaIconeNom> = {
  revue: "list-checks",
  echeance: "clock-clockwise",
  relance: "paper-plane-tilt",
  verrouillage: "lock-simple",
  depot: "calendar-check",
};

interface PanneauNotificationsProps {
  sections: SectionDeNotifications[];
  onFermer?: () => void;
  onToutMarquerLu?: () => void;
  onRegler?: () => void;
}

function sujetEnIcone(sujet?: SujetDeNotification) {
  return sujet ? ICONE_PAR_SUJET[sujet] : undefined;
}

export function PanneauNotifications({
  sections,
  onFermer,
  onToutMarquerLu,
  onRegler,
}: PanneauNotificationsProps) {
  const nonLues = sections
    .flatMap((section) => section.notifications)
    .filter((notification) => notification.nonLue).length;

  return (
    <aside className="cnotifs" aria-label="Notifications">
      <div className="cnotifs__tete">
        <span className="cnotifs__titre">Notifications</span>
        <button
          type="button"
          className="cnotifs__lien"
          onClick={onToutMarquerLu}
        >
          Tout marquer comme lu
        </button>
        <button
          type="button"
          className="cnotifs__fermer"
          aria-label="Fermer les notifications"
          onClick={onFermer}
        >
          <ComptaIcone nom="x" taille={14} />
        </button>
      </div>

      <div className="cnotifs__corps">
        {sections.map((section) => (
          <div key={section.titre}>
            <div className="cnotifs__cap">{section.titre}</div>
            {section.notifications.map((notification) => {
              const icone = sujetEnIcone(notification.sujet);
              return (
                <div key={notification.id} className="cnotifs__element">
                  <span className="cnotifs__disque">
                    {icone ? (
                      <ComptaIcone nom={icone} taille={16} />
                    ) : (
                      notification.initiales
                    )}
                  </span>
                  <span className="cnotifs__texte">
                    <span className="cnotifs__element-titre">
                      {notification.titre}
                    </span>
                    <span className="cnotifs__element-detail">
                      {notification.detail}
                    </span>
                  </span>
                  {notification.nonLue && <span className="cnotifs__point" />}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <div className="cnotifs__pied">
        <span className="cnotifs__compteur">
          {nonLues} non lue{nonLues > 1 ? "s" : ""}
        </span>
        <button type="button" className="cnotifs__lien" onClick={onRegler}>
          Régler mes notifications
        </button>
      </div>
    </aside>
  );
}
